import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TwoFactorMessagesHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/two-factor-messages'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'two_factor_messages_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'two_factor_messages_list',
          component: TwoFactorMessagesHome,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
